import { Button, Icon } from 'semantic-ui-react';

import { useEffect, useState } from 'react';

import { CashierBalances, DailyReportCreate, LoadingSpinner, ErrorMessage } from '../../components';
import { CashierService } from '../../services';
import { FeedbackMessage } from '../../constants';


export function CashierTillPage() {

    const [closeMode, setCloseMode] = useState(false);
    const [isTillOpened, setIsTillOpened] = useState<boolean>(false);
    const [checkingTillStatus, setCheckingTillStatus] = useState(true);
    const [openingTill, setOpeningTill] = useState(false);

    const [errorLoadingData, setErrorLoadingData] = useState(false)
    const [errorOpeningTill, setErrorOpeningTill] = useState(false)
    const [errorFetchingTillStatus, setErrorFetchingTillStatus] = useState(false)

    useEffect(() => {

        setTimeout(() => {
            getMyTillStatus()
        }, 1000);
    }, []);


    const getMyTillStatus = async () => {
        try {
            const status = await CashierService.getMyTillStatus();
            setIsTillOpened(status);
        }
        catch (e) {
            setErrorFetchingTillStatus(true)
        }
        finally {
            setCheckingTillStatus(false);
        }
    }

    const handleOpenTill = async () => {

        setOpeningTill(true)

        try {
            await CashierService.openMyTill()
            setIsTillOpened(true)
        }
        catch (e) {
            setErrorOpeningTill(true)
        }
        finally {
            setOpeningTill(false)
        }

    }

    const OpenButton = <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
        <h2>Votre caisse est fermée</h2>
        <p className="size-17">Vous devez ouvrir votre caisse pour pouvoir recevoir de l'argent</p>
        <br />
        <br />
        <br />
        <Button size='huge' secondary onClick={handleOpenTill} loading={openingTill}>
            <Icon name='unlock alternate' />
            Ouvrir ma caisse <Icon name='arrow alternate circle right outline' />
        </Button>
    </div>

    const CloseButton = <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
        <Button size='huge' secondary onClick={() => setCloseMode(true)}>
            <Icon name="lock" /> Clôturer ma caisse
        </Button>
    </div>

    const confirmCloseButtons = <div>
        <div>
            <Button size='huge' color='orange' onClick={() => setCloseMode(false)}>
                <Icon name='window close' />
                Annuler la cloture
            </Button>
            <Button size='huge' secondary onClick={() => setCloseMode(false)}>
                Clôturer la caisse
            </Button>
        </div>
    </div>

    return <div style={{ display: 'flex', width:' 100%',flexDirection: 'column'}}>

        {checkingTillStatus && <LoadingSpinner />}
        {errorLoadingData && <ErrorMessage errorText={FeedbackMessage.CASH_RECEPTION_FETCH_ERROR} />}
        {errorOpeningTill && <ErrorMessage errorText={FeedbackMessage.TILL_OPENING_ERROR} />}
        {errorFetchingTillStatus && <ErrorMessage errorText={FeedbackMessage.TILL_STATUS_FETCH_ERROR} />}

        {
            !checkingTillStatus && <>

                {isTillOpened && !closeMode && <CashierBalances />}

                {!isTillOpened && OpenButton}

                {isTillOpened && !closeMode && CloseButton}

                {
                    closeMode && <>

                        <DailyReportCreate />

                        {confirmCloseButtons}
                    </>
                }
            </>
        }
    </div>
}